import { Discount } from '@esportal/portal-service';
import { HuchaTier } from '../models/hucha-values';

export const RENOVADOR_PLUS15 = '701Tr00000w5Vt3IAE';
export const RENOVADOR_STANDARD = '701QF00001fu4VTYAY';

export const getHuchaTierFromDiscounts = (discounts: Discount[] = []): HuchaTier => {
	const discountIds = discounts.map((discount) => discount.id);

	if (discountIds.includes(RENOVADOR_PLUS15)) return 'renovadorPlus15';
	if (discountIds.includes(RENOVADOR_STANDARD)) return 'renovador10To15';

	return 'standard';
};

export const getRenovadorDiscountId = (huchaTier: HuchaTier) => {
	switch (huchaTier) {
		case 'renovadorPlus15':
			return RENOVADOR_PLUS15;
		case 'renovador10To15':
			return RENOVADOR_STANDARD;
		default:
			return '';
	}
};
